export const HpStripeRefreshPage: React.FC = () => {
  return (
    <div className="w-screen h-screen flex flex-col gap-8 justify-center items-center">
      <div>
        <h1>Stripe Redirect page!</h1>
      </div>
    </div>
  );
};
